import hitTemplate from './algolia-hit-template.js';

let lastRenderArgs;

export const infiniteHits = instantsearch.connectors.connectInfiniteHits(
  (renderArgs, isFirstRender) => {
    const {
      hits,
      showMore,
      widgetParams,
      components,
      html
    } = renderArgs;

    const { container } = widgetParams;
    
    lastRenderArgs = renderArgs;

    if (isFirstRender) {
      const sentinel = document.createElement('div');
      container.appendChild(document.createElement('ul'));
      container.appendChild(sentinel);

      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !lastRenderArgs.isLastPage) {
            showMore();
          }
        });
      });

      observer.observe(sentinel);
      return;
    }

    container.querySelector('ul').innerHTML = hits
      .map(hit => hitTemplate(null, hit, html, components)).join('');
  }
);
